export class Agent {
    id:string;
    name:string;
}